import type {
  PageCheckoutLineItem,
  PageCheckoutSettings,
  PageOnCheckoutSuccessAction,
} from "./pageFormSubmit";

export type NodePosition = { x: number; y: number };

export type WaitStepMode = "duration" | "until";
export type WaitStepUnit = "seconds" | "minutes" | "hours" | "days";

export interface AutomationStep {
  id: string;
  type: "sms" | "wait" | "instagram.sendMessage" | "email" | "emailCampaign" | "mailerlite.createSubscriber" | "laylo.createSubscriber" | "manychat.createSubscriber" | "beehiiv.createSubscriber" | "meta.addToAudience" | "page" | "createContact" | "checkout";
  data: {
    body?: string;
    subject?: string;
    campaignId?: string;
    mode?: WaitStepMode;
    duration?: string;
    unit?: WaitStepUnit;
    untilAt?: string;
    timezone?: string;
    buttons?: { text: string; targetStepId?: string }[];
    groupIds?: string[];
    tagIds?: string[];
    automationIds?: string[];
    businessId?: string;
    adAccountId?: string;
    audienceId?: string;
    pageId?: string;
    formTargetStepIds?: Record<string, string>;
    pageResponseId?: string;
    lineItems?: PageCheckoutLineItem[];
    onCheckoutSuccess?: PageOnCheckoutSuccessAction[];
    checkoutSettings?: PageCheckoutSettings;
    [key: string]: unknown;
  };
  next?: string;
  position?: NodePosition;
}

export interface AutomationStepPage extends Omit<AutomationStep, "type" | "data"> {
  type: "page";
  data: {
    pageId?: string;
    formTargetStepIds?: Record<string, string>;
    pageResponseId?: string;
  };
}

export function isAutomationStepPage(step: AutomationStep): step is AutomationStepPage {
  return step.type === "page";
}

export interface AutomationStepCheckout extends Omit<AutomationStep, "type" | "data"> {
  type: "checkout";
  data: {
    lineItems?: PageCheckoutLineItem[];
    onCheckoutSuccess?: PageOnCheckoutSuccessAction[];
    checkoutSettings?: PageCheckoutSettings;
  };
}

export function isAutomationStepCheckout(
  step: AutomationStep
): step is AutomationStepCheckout {
  return step.type === "checkout";
}

export interface AutomationTrigger {
  type: "contacts.create" | "instagram.comment";
  next?: string;
  data?: {
    commentType?: "any" | "keywords";
    keywords?: string[];
    keywordMatch?: "startsWith" | "includes";
    publicReplies?: string[];
  };
  position?: NodePosition;
}
